/* hs-eslint ignored failing-rules */

/* eslint-disable react/prop-types */
'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import hubspot from 'hubspot';
import classNames from 'classnames';
const flagsImagePath = `${hubspot.bender && hubspot.bender.staticDomainPrefix}/ui-addon-i18n/static-1.5702/img/flags.png`;
export default class CountryFlag extends Component {
  constructor(...args) {
    super(...args);

    this.getFlagStyle = () => {
      return {
        backgroundImage: `url(${flagsImagePath})`
      };
    };
  }

  render() {
    const _this$props = this.props,
          {
      countryCode,
      className
    } = _this$props,
          passThroughProps = _objectWithoutPropertiesLoose(_this$props, ["countryCode", "className"]);

    return /*#__PURE__*/_jsx("span", Object.assign({}, passThroughProps, {
      className: classNames('country-flag', className, countryCode.toLowerCase()),
      style: this.getFlagStyle()
    }));
  }

}
CountryFlag.propTypes = {
  countryCode: PropTypes.string.isRequired
};